export default __webpack_public_path__ + "static/media/workflow.22fea134.png";